import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { BInputError } from './index';

const BTextarea = ({
  label,
  name,
  isDirty = false,
  isHidden = false,
  placeholder = '',
  maxLength = 100,
  minLength = 5,
  icon: Icon,
  errors,
  ...props
}) => {
  const textareaRef = useRef(null);
  const [charCount, setCharCount] = useState(0);
  const handleInput = (e) => {
    setCharCount(e.target.value.length || 0);
  };
  useEffect(() => {
    if (textareaRef.current) {
      setCharCount(textareaRef.current.value.length);
    }
  }, []);
  return (
    <div className={'flex w-full flex-col gap-1'} hidden={isHidden}>
      <div className={'text-sm font-normal text-slate-700'}>{label}</div>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3">
          {Icon && <Icon className={'size-4 text-slate-500'} />}
        </div>
        <textarea
          onInput={handleInput}
          ref={textareaRef}
          rows={4}
          hidden={isHidden}
          className={`w-full py-3 ${Icon ? 'ps-8' : 'px-4'} focus:outline-primary-600 rounded-lg border border-slate-300 bg-slate-100 text-base leading-tight font-normal text-slate-600 placeholder-slate-400 invalid:outline-red-600 focus:outline-2 ${isDirty ? 'italic' : 'normal'}`}
          name={name}
          placeholder={placeholder}
          {...props}
        />
        {(minLength > 0 || maxLength > 0) && (
          <div className={clsx('text-right text-xs', charCount < minLength ? 'text-red-400' : 'text-green-400')}>
            {charCount} / {minLength}
          </div>
        )}
        <BInputError errors={errors} />
      </div>
    </div>
  );
};

export default BTextarea;
